import { render } from "./shareBonus.vue?vue&type=template&id=696f8a3f&scoped=true"
import script from "./shareBonus.vue?vue&type=script&lang=js"
export * from "./shareBonus.vue?vue&type=script&lang=js"

import "./shareBonus.vue?vue&type=style&index=0&id=696f8a3f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696f8a3f"]])

export default __exports__